export default __webpack_public_path__ + "static/media/LENS_CULINARIS_ATHILA_2.3624d045.jpg";